<template>
  <form class="needs-validation ml-0" @submit.prevent="completeForm" novalidate>
    <div class="col px-0 pr-lg-3">
      <section class="bg-white rounded mb-4 p-3 p-sm-4">
        <div class="d-flex justify-content-between align-items-start mb-4">
          <h1 class="h2 mb-3">{{ details ? details.name : '' }}</h1>
        </div>
        <div role="alert" class="alert alert-warning" v-if="errors">{{ errors }}</div>
        <div class="row align-items-start">
          <div class="col-12 col-md-6 form-group no-gutters pr-xl-4">
            <label for="titleName">Title Name <small>(National)</small></label>
            <input type="text" class="form-control" id="titleName" required v-model="titleDetails.championship_name">
            <div class="invalid-tooltip">Please include the National Title Name.</div>
          </div>

          <div class="col-12 col-md-6 pl-xl-4 form-group">
            <label for="titleNameZone">Title Name <small>(Zone)</small></label>
            <input type="text" class="form-control" id="titleNameZone" required v-model="titleDetails.name">
            <div class="invalid-tooltip">Please include the Zone Title Name.</div>
          </div>

          <div class="col-12 col-md-6 pr-xl-4 form-group">
            <div class="mb-3">
              <label for="sponsorName">Sponsor</label>
              <input type="text" class="form-control" id="sponsorName" v-model="titleDetails.sponsor_name">
              <div class="invalid-tooltip">Please include the Sponsor Name.</div>
            </div>
            <label for="sponsorLink">Sponsor Link</label>
            <input type="text" class="form-control" id="sponsorLink" v-model="titleDetails.sponsor_link">
            <div class="invalid-tooltip">Please include the Sponsor Link.</div>
          </div>

          <div class="col-12 col-md-6 pl-xl-4 form-group">
            <label for="sponsorLogo">Sponsor Logo</label>
            <div class="custom-file">
              <input type="file"
                :class="['custom-file-input font-weight-normal', { 'is-invalid': validation['sponsor_logo'].status === 'error' }]"
                id="sponsorLogo" accept="image/jpeg,image/png,image/webp,image/svg+xml,image/bmp" @change="sponsorLogoFileUpload">
              <label class="custom-file-label font-weight-normal" for="sponsorLogo">{{ sponsorLogoFileName ?
                sponsorLogoFileName : 'Choose file...' }}</label>
              <div class="invalid-tooltip">{{ validation['sponsor_logo'].message }}</div>
            </div>
            <div class="border border-light rounded p-3 mt-2 position-relative" v-if="titleDetails.sponsor_logo">
              <div class="blockButtons d-flex flex-column">
                <button
                  @click.prevent="sponsorLogoFileName = ''; titleDetails.sponsor_logo_file = ''; titleDetails.sponsor_logo = ''"
                  class="d-flex justify-content-center align-items-center border border-white m-2"
                  aria-label="Remove Logo">
                  <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11">
                    <g>
                      <path fill="#231815"
                        d="M10.5499992 10.9500008c-.1 0-.3 0-.4-.1l-10-10c-.2-.2-.2-.5 0-.7s.5-.2.7 0l10 10c.2.2.2.5 0 .7 0 .1-.2.1-.3.1z" />
                      <path fill="#231815"
                        d="M.5499992 10.9500008c-.1 0-.3 0-.4-.1-.2-.2-.2-.5 0-.7l10-10c.2-.2.5-.2.7 0s.2.5 0 .7l-10 10c0 .1-.2.1-.3.1z" />
                    </g>
                  </svg>
                </button>
              </div>
              <img :src="titleDetails.sponsor_logo" class="img-fluid" :alt="titleDetails.sponsor_name">
            </div>
          </div>

          <div class="col-12 col-md-6 pl-xl-4 form-group"></div>

          <div class="col-12 col-md-6 pl-xl-4 form-group">
            <label for="titleLogo">Title Logo</label>
            <div class="custom-file">
              <input type="file"
                :class="['custom-file-input font-weight-normal', { 'is-invalid': validation['title_logo'].status === 'error' }]"
                id="titleLogo" accept="image/jpeg,image/png,image/webp,image/svg+xml,image/bmp" @change="titleLogoFileUpload">
              <label class="custom-file-label font-weight-normal" for="titleLogo">{{ titleLogoFileName ?
                titleLogoFileName : 'Choose file...' }}</label>
              <div class="invalid-tooltip">{{ validation['title_logo'].message }}</div>
            </div>
            <div class="border border-light rounded p-3 mt-2 position-relative" v-if="titleDetails.title_logo">
              <div class="blockButtons d-flex flex-column">
                <button
                  @click.prevent="titleLogoFileName = ''; titleDetails.title_logo_file = ''; titleDetails.title_logo = ''"
                  class="d-flex justify-content-center align-items-center border border-white m-2"
                  aria-label="Remove Logo">
                  <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11">
                    <g>
                      <path fill="#231815"
                        d="M10.5499992 10.9500008c-.1 0-.3 0-.4-.1l-10-10c-.2-.2-.2-.5 0-.7s.5-.2.7 0l10 10c.2.2.2.5 0 .7 0 .1-.2.1-.3.1z" />
                      <path fill="#231815"
                        d="M.5499992 10.9500008c-.1 0-.3 0-.4-.1-.2-.2-.2-.5 0-.7l10-10c.2-.2.5-.2.7 0s.2.5 0 .7l-10 10c0 .1-.2.1-.3.1z" />
                    </g>
                  </svg>
                </button>
              </div>
              <img :src="titleDetails.title_logo" class="img-fluid" :alt="titleDetails.sponsor_name">
            </div>
          </div>

          <div class="col-12 d-lg-none">
            <button class="btn btn-block-mob btn-primary" type="submit" @click="handleSubmit">Update</button>
          </div>
        </div>
      </section>

      <rookie v-if="titleDetails.id === 4" />
      <sire v-if="titleDetails.id === 5" />
    </div>

    <desktop-action-bar>
      <button :class="['btn btn-block px-md-5', processing ? 'btn-primary-dark' : 'btn-primary']" type="submit"
        @click="handleSubmit">
        {{ !processing ? 'Update' : '' }}
        <div v-if="processing" class="spinner-border text-light" role="status"><span
            class="sr-only">Loading...</span></div>
      </button>
    </desktop-action-bar>
  </form>
</template>

<script>
import axios from 'axios'
import HANDLESUBMIT from '@/mixins/formValidation.js'
import DesktopActionBar from '@/components/DesktopActionBar'
import sire from './TitleEditDetailsSire'
import rookie from './TitleEditDetailsRookie'

export default {
  name: 'TitleEditDetails',
  props: ['details'],
  mixins: [HANDLESUBMIT],
  components: {
    rookie,
    sire,
    DesktopActionBar
  },
  data() {
    return {
      titleDetails: this.details ? { ...this.details } : { sponsor_logo_file: '', title_logo_file: '' },
      sponsorLogoFileName: this.details ? this.details.sponsor_logo : '',
      titleLogoFileName: this.details ? this.details.title_logo : '',
      validation: {
        title_logo: {
          status: '',
          message: ''
        },
        sponsor_logo: {
          status: '',
          message: ''
        }
      },
      errors: '',
      processing: false
    }
  },
  methods: {
    completeForm() {
      setTimeout(() => {
        if (this.formComplete) {
          this.addTitle()
        }
      }, 10)
    },
    addTitle() {
      const formData = new FormData()
      formData.append('sponsor_logo_file', this.titleDetails.sponsor_logo_file)
      formData.append('title_logo_file', this.titleDetails.title_logo_file)
      formData.append('fields', JSON.stringify(this.titleDetails))
      this.processing = true
      axios.post(`${this.$api}/admin/title-edit`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then((response) => {
        this.processing = false
        if (response.data.status === 'success') {
          this.$router.push({ name: 'Titles', params: { success: `Great! Your title has been successfully edited.` } })
        } else {
          this.errors = 'Something went wrong. Please reload the page.'
        }
      }).catch(() => {
        this.processing = false
        this.errors = 'Unable to receive data from the server. Please reload the page.'
      })
    },
    sponsorLogoFileUpload(event) {
      const uploadedFile = event.target.files[0]

      if (this.validateFile(uploadedFile, 'sponsor_logo', 2)) {
        this.titleDetails.sponsor_logo_file = uploadedFile
        this.titleDetails.sponsor_logo = URL.createObjectURL(uploadedFile)
        this.sponsorLogoFileName = uploadedFile.name
      }
    },
    titleLogoFileUpload(event) {
      const uploadedFile = event.target.files[0]

      if (this.validateFile(uploadedFile, 'title_logo', 2)) {
        this.titleDetails.title_logo_file = uploadedFile
        this.titleDetails.title_logo = URL.createObjectURL(uploadedFile)
        this.titleLogoFileName = uploadedFile.name
      }
    },
    validateFile(uploadedFile, key, maxSizeMB) {
      const maxSize = maxSizeMB * 1024 * 1024

      let status = true

      if (uploadedFile.size > maxSize) {
        status = false
        this.errors = 'The file you are uploading is too large.'
        this.validation[key].status = 'error'
        this.validation[key].message = 'The file should be less that 2MB.'
      } else {
        this.errors = ''
        this.validation[key].status = ''
        this.validation[key].message = ''
      }

      return status
    }
  },
  mounted() {
    /* Boot out user if there's no details to show */
    this.$nextTick(() => {
      if (!this.details) {
        this.$router.push({ name: 'Titles' })
      }
    })
  }
}
</script>




// WEBPACK FOOTER //
// src/views/Titles/Edit/TitleEditDetails.vue